import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Field } from 'redux-form';
import { required } from 'redux-form-validators';
import { FormInputContainerComponent, ItemComponent } from './InputWrappersComponent';

const renderTextarea = ({ input, meta, label, classNameInputContainer }) => {
    return (
        <FormInputContainerComponent
            className={classNameInputContainer ? classNameInputContainer : ''}>
            <label htmlFor={input.name} className="label">
                {label}
            </label>
            <ItemComponent className="item item-textarea">
                <textarea
                    {...input}
                    id={`${input.name}-${meta.form}`}
                    className={`input ${meta.touched && meta.error ? ' input-error' : ''}`}
                />
            </ItemComponent>
            {meta.touched && meta.error && <p className="color-err small">{meta.error}</p>}
        </FormInputContainerComponent>
    );
};

class TextareaFieldComponent extends Component {
    validateDefault = () => {
        if (this.props.isRequired) {
            return [
                required({
                    msg: this.props.i18nFeatureForm.REQUIRED,
                    allowBlank: !this.props.isRequired
                })
            ];
        }
        return [];
    };

    render() {
        const { validate = [], label, isRequired } = this.props;
        return (
            <Field
                {...this.props}
                label={`${label ? label : ''}${label && isRequired ? '*' : ''}`}
                component={renderTextarea}
                validate={[...this.validateDefault(), ...validate]}
            />
        );
    }
}

TextareaFieldComponent.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    isRequired: PropTypes.bool,
    i18nFeatureForm: PropTypes.object
};

export default TextareaFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/TextareaFieldComponent.js